import { wait } from "../../utils/mock";

// návrh, nabídka, objednáno, fakturováno, zaplaceno
export const estimateStates = {
    DRAFT: {},
    PROPOSED: {
        canGoBack: true,
    },
    ORDERED: {},
    INVOICED: {},
    PAID: {},
};

export const mockProud = {
    name: "Proud 2025",
    clientName: "Pilsner Urquell",
    state: "DRAFT",
};

export const mockKaufland = {
    name: "Kaufland 2025",
    clientName: "Kaufland",
    state: "ACCEPTED",
    stateChanged: "2024-01-01",
};

export const fetchEstimateList = async (filter) => {
    console.log("fetching estimates", filter);
    await wait(1450);
    const items = [];
    for (let i = 0; i < 24; i++) {
        items.push({ ...mockProud, id: `proud-${i * 2}` });
        items.push({ ...mockKaufland, id: `kaufland-${i}` });
    }

    return {
        isFirst: true,
        hasMore: false,
        items,
    };
};

export const fetchEstimateOverview = async ({ filter }) => {
    await wait(1234);
    return {
        currencyCode: "CZK",
        totals: {
            currencyCode: "CZK",
            balance: {
                current: 1789000,
                previous: 1600000,
                diffPercent: 12,
            },
            income: {
                current: 2200000,
                previous: 1900000,
                diffPercent: 9,
            },
            expenditure: {
                current: 580000,
                previous: 500000,
                diffPercent: 16,
            },
        },
    };
};

export const pricelistItemTypes = [
    "FIELDS",
    "TITLE",
    "SUM",
    "PERCENT",
    "UNIT_PRICE",
    "FIXED_AMOUNT",
    "PERCENTAGE",
];

export const fetchEstimateDetail = async (id) => {
    console.log("fetching detail", id);
    const [type] = id.split("-");
    await wait(1234);
    switch (type) {
        case "proud":
            return {
                ...mockProud,
                id,
                currency: "CZK",
                items: [
                    {
                        type: "FIELDS",
                        rows: 2,
                        fields: [
                            { label: "Klient", type: "CLIENT", value: "" },
                            { label: "Projekt", type: "PROJECT", value: "" },
                            { label: "Typ projektu", type: "TEXT", value: "" },
                            { label: "Lokalita", type: "TEXT", value: "" },
                        ],
                    },
                    { type: "TITLE", title: "Termín", level: 1 },
                    {
                        type: "FIELDS",
                        rows: 2,
                        fields: [
                            { label: "Datum", type: "DATE", value: "" },
                            { label: "Počet dní", type: "TEXT", value: "" },
                        ],
                    },
                    { type: "TITLE", title: "Náklady", level: 1 },
                    { type: "TITLE", title: "Mzdové náklady", level: 2 },
                    {
                        type: "CALCULATED_ITEM",
                        label: "Graphic designer",
                        billedUnitPrice: 600,
                        quantity: 1,
                        unit: "h",
                        description: "grafické práce, 3D vizualizace, DTP",
                        unitPrice: 500,
                        unitProfit: 100,
                    },
                    { type: "TITLE", title: "Součet", level: 1 },
                    { type: "SUM", title: "TOTAL veškeré aktivity" },
                    { type: "PERCENT", title: "Agenturní provize 10%", percentage: 10 },
                    { type: "TITLE", title: "Celkem", level: 1 },
                    { type: "SUM" },
                ],
            };
        case "kaufland":
            return { ...mockKaufland, id, items: [] };
        default:
            return { id };
    }
};

export const saveEstimate = async (data) => {
    await wait(3402);
};

const mockPilsner = {
    name: "Pilsner Urquell 2025",
    clientName: "Pilsner Urquell",
    location: "Plzeň",
};

export const fetchPricelistList = async (filter) => {
    await wait(1450);
    const items = [];
    for (let i = 0; i < 48; i++) {
        items.push({ ...mockPilsner, id: `proud-${i * 2}` });
        items.push({ ...mockKaufland, id: `kaufland-${i}` });
    }

    return {
        isFirst: true,
        hasMore: false,
        items,
    };
};

export const fetchPricelistDetail = async (id) => {
    console.log("fetching detail", id);
    const [type] = id.split("-");
    await wait(1234);
    switch (type) {
        case "proud":
            return {
                ...mockProud,
                id,
                currency: "CZK",
                items: [
                    {
                        type: "FIELDS",
                        rows: 2,
                        fields: [
                            { label: "Klient", type: "CLIENT", value: "" },
                            { label: "Projekt", type: "PROJECT", value: "" },
                            { label: "Typ projektu", type: "TEXT", value: "" },
                            { label: "Lokalita", type: "TEXT", value: "" },
                        ],
                    },
                    { type: "TITLE", title: "Termín", level: 1 },
                    {
                        type: "FIELDS",
                        rows: 2,
                        fields: [
                            { label: "Datum", type: "DATE", value: "" },
                            { label: "Počet dní", type: "TEXT", value: "" },
                        ],
                    },
                    { type: "TITLE", title: "Náklady", level: 1 },
                    { type: "TITLE", title: "Mzdové náklady", level: 2 },
                    {
                        type: "UNIT_PRICE",
                        label: "Graphic designer",
                        billedUnitPrice: 600,
                        quantity: 1,
                        unit: "h",
                        description: "grafické práce, 3D vizualizace, DTP",
                        unitPrice: 500,
                        unitProfit: 100,
                    },
                    { type: "TITLE", title: "Součet", level: 1 },
                    { type: "SUM", title: "TOTAL veškeré aktivity" },
                    {
                        type: "PERCENTAGE",
                        title: "Agenturní provize 10%",
                        billedPercentage: 10,
                        percentage: 0,
                    },
                    { type: "FIXED_AMOUNT", title: "Celkem", billedAmount: 1000, amount: 0 },
                    { type: "TITLE", title: "Celkem", level: 1 },
                    { type: "SUM" },
                ],
            };

        case "kaufland":
            return { ...mockKaufland, id };
        default:
            return { id };
    }
};

export const savePricelist = async (data) => {
    await wait(3402);
};
